import React from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Paper,
  CircularProgress,
  Divider,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useGetPageBySlug } from '../../hooks/storefront/useGetPageBySlug';

const PageBySlug = () => {
  const { slug } = useParams();
  const { t, i18n } = useTranslation();
  const lng = i18n.language || "en";

  const { isLoading, page } = useGetPageBySlug(slug);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!page) {
    return (
      <Box sx={{ py: 8 }}>
        <Container>
          <Typography variant="h5" textAlign="center">
            {t('Page not found')}
          </Typography>
        </Container>
      </Box>
    );
  }

  const title = page.title?.[lng] || page.title?.en || page.title?.ar || "";
  const content = page.content?.[lng] || page.content?.en || page.content?.ar || "";

  return (
    <Box sx={{ py: 6 }}>
      <Container maxWidth="lg">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 5 },
            borderRadius: 3,
            border: (theme) => `1px solid ${theme.palette.divider}`,
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.02)' : '#ffffff'
          }}
        >
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            fontWeight="900"
            sx={{
              mb: 3,
              fontSize: { xs: '2rem', md: '3rem' },
              color: 'primary.main'
            }}
          >
            {title}
          </Typography>

          <Divider sx={{ mb: 4 }} />

          <Box
            className="page-content"
            sx={{
              lineHeight: 1.8,
              fontSize: '1.1rem',
              '& h1, & h2, & h3': { mt: 3, mb: 2, fontWeight: 'bold' },
              '& p': { mb: 2 },
              '& ul, & ol': { mb: 2, pl: 3 },
              '& img': { maxWidth: '100%', height: 'auto', borderRadius: 2 }
            }}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </Paper>
      </Container>
    </Box>
  );
};

export default PageBySlug;
